export const API_BASE_URL = "https://talentify-backend.onrender.com/";
// export const API_BASE_URL = "http://localhost:8000/";

export const LOCAL_STORAGE_TOKEN_KEY = "talenter_token_key";
